import Logger from "../../../../core/internal/logger"
import { InAppMessageScheduleRequest } from "../InAppMessageScheduleRequest"
import { InAppMessageScheduleAction } from "./InAppMessageScheduleAction"

export class InAppMessageScheduleActionDeterminer {
  /**
   * Deliver only requests made within the past 10 seconds
   */
  private readonly DELIVER_DURATION_THRESHOLD_MILLIS = -1 * 10 * 1000

  private shouldIgnoreRequest(request: InAppMessageScheduleRequest): boolean {
    if (request.scheduleType !== "STORED") return false

    const delayMillis = request.delayMillis
    return delayMillis < 0
  }

  private determineAction(request: InAppMessageScheduleRequest): InAppMessageScheduleAction {
    const delayMillis = request.delayMillis
    if (delayMillis > 0) {
      return "DELAY"
    }

    if (delayMillis >= this.DELIVER_DURATION_THRESHOLD_MILLIS) {
      return "DELIVER"
    }

    if (delayMillis < this.DELIVER_DURATION_THRESHOLD_MILLIS) {
      return "IGNORE"
    }

    throw new Error(`InAppMessageScheduleAction cannot be determined (key=${request.schedule.inAppMessageKey})`)
  }

  determine(request: InAppMessageScheduleRequest): InAppMessageScheduleAction {
    if (this.shouldIgnoreRequest(request)) {
      return "IGNORE"
    }

    const action = this.determineAction(request)
    Logger.log.debug(
      `InAppMessage ScheduleAction determined: action=${action}, dispatchId=${request.schedule.dispatchId}`
    )
    return action
  }
}
